import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-installation-modal',
  templateUrl: './installation-modal.component.html',
  styles: [`
    @media (max-width: 639px) {
      :host ::ng-deep .install-modal-box {
        max-height: 65vh !important;
        max-width: 92vw !important;
        margin: auto;
      }
      :host ::ng-deep .install-modal-wrapper {
        padding: 0.75rem !important;
      }
    }
  `]
})
export class InstallationModalComponent implements OnChanges, OnDestroy {
  @Input() isOpen = false;
  @Output() agreed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  @ViewChild('modalOverlay') modalOverlay!: ElementRef;
  @ViewChild('modalWrapper') modalWrapper!: ElementRef;

  private movedToBody = false;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isOpen']) {
      if (this.isOpen) {
        document.body.style.overflow = 'hidden';
        // Move modal elements to body after view renders
        setTimeout(() => this.moveToBody(), 0);
      } else {
        document.body.style.overflow = '';
        this.removeFromBody();
      }
    }
  }

  ngOnDestroy() {
    document.body.style.overflow = '';
    this.removeFromBody();
  }

  private moveToBody() {
    if (this.movedToBody) return;
    const overlay = this.modalOverlay?.nativeElement;
    const wrapper = this.modalWrapper?.nativeElement;
    if (overlay) document.body.appendChild(overlay);
    if (wrapper) document.body.appendChild(wrapper);
    this.movedToBody = true;
  }

  private removeFromBody() {
    if (!this.movedToBody) return;
    const overlay = this.modalOverlay?.nativeElement;
    const wrapper = this.modalWrapper?.nativeElement;
    if (overlay?.parentNode === document.body) document.body.removeChild(overlay);
    if (wrapper?.parentNode === document.body) document.body.removeChild(wrapper);
    this.movedToBody = false;
  }

  onAgree() {
    this.teardown();
    this.agreed.emit();
  }

  /** Dismiss without accepting — installation must not be applied. */
  onCancel() {
    this.teardown();
    this.cancelled.emit();
  }

  private teardown() {
    document.body.style.overflow = '';
    this.removeFromBody();
  }
}
